<template>
    <span>{{city}}</span>
</template>

<script>
    export default {
        name: 'getCity',
        data: () => ({
            city: null
        }),
        methods: {
            getCity: function () {
                let x = location.origin + location.pathname;
                return fetch(x + './modules/getCity.php')
                    .then(function (response) {
                        return response.json();
                    })
            }
        },
        created() {
            let app = this;
            this.getCity().then(function (response) {
                app.city = response.city
            }).catch(console.log());
        }
    }
</script>